var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "layout-primary",
    { attrs: { "title-text": _vm.titleText } },
    [
      _vm._t("titleAction", null, { slot: "titleAction" }),
      _vm._t("search", null, {
        slot: "headerRight",
        filter: _vm.filter,
        filters: _vm.pageModel.filters
      }),
      _vm._t("header", null, { slot: "headerContent" }),
      _vm._t("notification", null, { slot: "notification" }),
      _vm._t("filters", null, {
        slot: "preContent",
        filter: _vm.filter,
        sort: _vm.sort,
        filters: _vm.pageModel.filters
      }),
      _vm.$mq === "mobile" && _vm.pageModel.hasMobileView
        ? _c("scroll-view", {
            attrs: {
              id: "mobile-view",
              identifier: "mv-" + _vm.pageModel.stateVersion,
              "data-provider": _vm.pageModel
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "item-tpl",
                  fn: function(ref) {
                    var listItem = ref.listItem
                    return [
                      _vm._t("mobile-item-tpl", null, { listItem: listItem })
                    ]
                  }
                }
              ],
              true
            )
          })
        : _vm._e(),
      _vm.$mq !== "mobile" || !_vm.pageModel.hasMobileView
        ? _c(
            "base-table",
            {
              attrs: {
                "fixed-header": _vm.pageModel.fixedHeader,
                "row-uniq-id": _vm.pageModel.uniqueField,
                columns: _vm.pageModel.columns,
                rows: _vm.pageModel.table.items,
                "default-sort": _vm.pageModel.table.order,
                actions: _vm.pageModel.actions,
                "actions-always-visible": _vm.pageModel.actionsAlwaysVisible,
                dependencies: _vm.pageModel.dependencies,
                "row-class": _vm.pageModel.rowClass,
                loading: _vm.pageModel.table.loading,
                "actions-width": _vm.pageModel.actionsWidth
              },
              on: { sort: _vm.sort },
              scopedSlots: _vm._u(
                [
                  _vm._l(_vm.pageModel.columns, function(col) {
                    return {
                      key: "column-" + col.field,
                      fn: function(slotData) {
                        return [
                          _vm._t("column-" + col.field, null, null, slotData)
                        ]
                      }
                    }
                  }),
                  {
                    key: "column-default-tpl",
                    fn: function(slotData) {
                      return [
                        _vm._t("column-default-tpl", null, null, slotData)
                      ]
                    }
                  },
                  {
                    key: "column-actions-tpl",
                    fn: function(slotData) {
                      return [
                        _vm._t("column-actions-tpl", null, null, slotData)
                      ]
                    }
                  }
                ],
                true
              )
            },
            [_vm._t("noData", null, { slot: "noData" })],
            2
          )
        : _vm._e(),
      _vm.$mq !== "mobile"
        ? _c("base-pagination", {
            staticClass: "list-page__footer",
            attrs: {
              slot: "pagination",
              "current-page": _vm.pageModel.table.page,
              results: _vm.pageModel.table.total,
              "items-per-page": _vm.pageModel.table.pageSize,
              "page-route": _vm.pageRoute
            },
            on: { paging: _vm.paging },
            slot: "pagination"
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }